import { PermissionWrapper } from '@dealstack/frontend/shared/components/PermissionWrapper/PermissionWrapper';
import {
	PermissionRole,
	ResourceType,
} from '@dealstack/shared/lib/common/fineGrainedAuthorization/permissions';
import { defaultToEmptyString } from '@dealstack/shared/lib/format/string';
import { useParams } from 'react-router-dom';

interface Props {
	children: React.ReactNode;
}

export const KycPermissions = ({ children }: Props) => {
	const { mipId } = useParams();
	return (
		<PermissionWrapper
			resourceType={ResourceType.PROGRAMME}
			resourceId={defaultToEmptyString(mipId)}
			permissionRole={PermissionRole.KYC_ADMIN}
		>
			{children}
		</PermissionWrapper>
	);
};
